import {
    apiRequest,
    pendidikanCreate
} from "../../../../../services/adapters/kepegawaian/pendidikanService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pendidikanCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository